const catalog = [
  {
    id: 'PASGT-IIIA-OMG-(color)-(size)',
    desc: 'PASGT Style, Omega Harness System. Size: Small, Medium, Large',
    manu: 'United Shield International',
    price: '$540.00',
  },
  {
    id: 'PASGT-IIIA-OMG-(color)-XL',
    desc: 'PASGT Style, Omega Harness System. Size: XLarge',
    manu: 'United Shield International',
    price: '$551.00',
  },
  {
    id: 'PASGT-IIIA-OMMBOA-(color)-(size)',
    desc: 'PASGT Style, Omega Mesh and BOA Harness. Size: Small, Medium, Large',
    manu: 'United Shield International',
    price: '$640.50',
  },
  {
    id: 'PASGT-IIIA-OMMBOA-(color)-XL',
    desc: 'PASGT Style, Omega Mesh and BOA Harness. Size: XLarge',
    manu: 'United Shield International',
    price: '$683.50',
  },
  {
    id: 'MCH-IIIA-OMG-(color)-(size)',
    desc: 'Full Cut Mich LE, Omega Harness System. Size: Small, Medium, Large',
    manu: 'United Shield International',
    price: '$595.00',
  },
  {
    id: 'MCH-IIIA-OMG-(color)-XL',
    desc: 'Full Cut Mich LE, Omega Harness System. Size: XLarge',
    manu: 'United Shield International',
    price: '$606.00',
  },
  {
    id: 'MCH-IIIA-4DSPSALP-(color)-(size)',
    desc: 'Full Cut Mich MIL, 4d 7pad system & Alpha Harness. Size: Small, Medium, Large',
    manu: 'United Shield International',
    price: '$661.50',
  },
  {
    id: 'MCH-IIIA-4DSPSALP-(color)-XL',
    desc: 'Full Cut Mich MIL, 4d 7pad system & Alpha Harness. Size: XLarge',
    manu: 'United Shield International',
    price: '$672.50',
  },
  {
    id: 'MCH-IIIA-OMMBOA-(color)-(size)',
    desc: 'Full Cut Mich LE, Omega Mesh and BOA Harness. Size: Small, Medium, Large',
    manu: 'United Shield International',
    price: '$661.50',
  },
  {
    id: 'MCH-IIIA-OMMBOA-(color)-XL',
    desc: 'Full Cut Mich LE, Omega Mesh and BOA Harness. Size: XLarge',
    manu: 'United Shield International',
    price: '$672.50',
  },
  {
    id: 'MCH-IIIA-4DSPSBOA-(color)-(size)',
    desc: 'Full Cut Mich MIL, BOA, 4d 7 pad system. Size: Small, Medium, Large',
    manu: 'United Shield International',
    price: '$705.50',
  },
  {
    id: 'MCH-IIIA-4DSPSBOA-(color)-XL',
    desc: 'Full Cut Mich MIL, BOA, 4d 7 pad system. Size: XLarge',
    manu: 'United Shield International',
    price: '$716.50',
  },
  {
    id: 'MCHM-IIIA-OMG-(color)-(size)',
    desc: 'Mid Cut Mich LE, Omega Harness System. Size: Small, Medium, Large',
    manu: 'United Shield International',
    price: '$595.00',
  },
  {
    id: 'MCHM-IIIA-OMG-(color)-XL',
    desc: 'Mid Cut Mich LE, Omega Harness System. Size: XLarge',
    manu: 'United Shield International',
    price: '$606.00',
  },
  {
    id: 'MCHM-IIIA-4DSPSALP-(color)-(size)',
    desc: 'Mid Cut Mich MIL, 4d 7pad system & Alpha Harness. Size: Small, Medium, Large',
    manu: 'United Shield International',
    price: '$661.50',
  },
  {
    id: 'MCHM-IIIA-4DSPSALP-(color)-XL',
    desc: 'Mid Cut Mich MIL, 4d 7pad system & Alpha Harness. Size: XLarge',
    manu: 'United Shield International',
    price: '$672.50',
  },
  {
    id: 'MCHM-IIIA-OMMBOA-(color)-(size)',
    desc: 'Mid Cut Mich LE, Omega Mesh and BOA Harness. Size: Small, Medium, Large',
    manu: 'United Shield International',
    price: '$661.50',
  },
  {
    id: 'MCHM-IIIA-OMMBOA-(color)-XL',
    desc: 'Mid Cut Mich LE, Omega Mesh and BOA Harness. Size: XLarge',
    manu: 'United Shield International',
    price: '$672.50',
  },
  {
    id: 'MCHM-IIIA-4DSPSBOA-(color)-(size)',
    desc: 'Mid Cut Mich MIL, BOA, 4d 7 pad system. Size: Small, Medium, Large',
    manu: 'United Shield International',
    price: '$705.50',
  },
  {
    id: 'MCHM-IIIA-4DSPSBOA-(color)-XL',
    desc: 'Mid Cut Mich MIL, BOA, 4d 7 pad system. Size: XLarge',
    manu: 'United Shield International',
    price: '$716.50',
  },
  {
    id: 'MCHH-IIIA-OMG-(color)-(size)',
    desc: 'High Cut Mich LE, Omega Harness System. Size: Small, Medium, Large',
    manu: 'United Shield International',
    price: '$595.00',
  },
  {
    id: 'MCHH-IIIA-OMG-(color)-XL',
    desc: 'High Cut Mich LE, Omega Harness System. Size: XLarge',
    manu: 'United Shield International',
    price: '$606.00',
  },
  {
    id: 'MCHH-IIIA-4DSPSALP-(color)-(size)',
    desc: 'High Cut Mich MIL, 4d 7pad system & Alpha Harness. Size: Small, Medium, Large',
    manu: 'United Shield International',
    price: '$661.50',
  },
  {
    id: 'MCHH-IIIA-4DSPSALP-(color)-XL',
    desc: 'High Cut Mich MIL, 4d 7pad system & Alpha Harness. Size: XLarge',
    manu: 'United Shield International',
    price: '$672.50',
  },
  {
    id: 'MCHH-IIIA-OMMBOA-(color)-(size)',
    desc: 'High Cut Mich LE, Omega Mesh and BOA Harness. Size: Small, Medium, Large',
    manu: 'United Shield International',
    price: '$661.50',
  },
  {
    id: 'MCHH-IIIA-OMMBOA-(color)-XL',
    desc: 'High Cut Mich LE, Omega Mesh and BOA Harness. Size: XLarge',
    manu: 'United Shield International',
    price: '$672.50',
  },
  {
    id: 'MCHH-IIIA-4DSPSBOA-(color)-(size)',
    desc: 'High Cut Mich MIL, BOA, 4d 7 pad system. Size: Small, Medium, Large',
    manu: 'United Shield International',
    price: '$705.50',
  },
  {
    id: 'MCHH-IIIA-4DSPSBOA-(color)-XL',
    desc: 'High Cut Mich MIL, BOA, 4d 7 pad system. Size: XLarge',
    manu: 'United Shield International',
    price: '$716.50',
  },
  {
    id: 'SOR-IIIA-(color)-Md',
    desc: 'Lightweight High Cut Spec Ops Rogue. Size: Medium',
    manu: 'United Shield International',
    price: '$1,748.00',
  },
  {
    id: 'SOR-IIIA-(color)-LG',
    desc: 'Lightweight High Cut Spec Ops Rogue. Size: Large',
    manu: 'United Shield International',
    price: '$1,748.00',
  },
  {
    id: 'SOR-IIIA-(color)-XL',
    desc: 'Lightweight High Cut Spec Ops Rogue. Size: XLarge',
    manu: 'United Shield International',
    price: '$1,748.00',
  },
  {
    id: 'MCHRG-IIIA-OMMBOA-(color)-(size)',
    desc: 'Lightweight Full Cut ACH Mich LE Rogue, Omega Mesh Harness, Boa',
    manu: 'United Shield International',
    price: '$1,204.00',
  },
  {
    id: 'MCHRG-IIIA-4DSPS-(color)-(size)',
    desc: 'Lightweight Full Cut ACH Mich MIL Rogue, 4d 7 pad system, Boa',
    manu: 'United Shield International',
    price: '$1,284.50',
  },
  {
    id: 'SPCO-IIIA-OMG-(color)-(Size)',
    desc: 'High Cut Spec Ops, Omega Harness System. Size: Small, Medium, Large',
    manu: 'United Shield International',
    price: '$683.00',
  },
  {
    id: 'SPCO-IIIA-OMG-(color)-XL',
    desc: 'High Cut Spec Ops, Omega Harness System. Size: XLarge',
    manu: 'United Shield International',
    price: '$740.50',
  },
  {
    id: 'SPCO-IIIA-OMMBOA-(color)-(Size)',
    desc: 'High Cut Spec Ops, Omega Mesh and BOA Harness. Size: Small, Medium, Large',
    manu: 'United Shield International',
    price: '$833.49',
  },
  {
    id: 'SPCO-IIIA-OMMBOA-(color)-XL',
    desc: 'High Cut Spec Ops, Omega Mesh and BOA Harness. Size: XLarge',
    manu: 'United Shield International',
    price: '$891.00',
  },
  {
    id: 'SODII-IIIA-(color)-(Size)',
    desc: 'High Cut Spec Ops Delta Gen II Size: Small, Medium, Large',
    manu: 'United Shield International',
    price: '$1,323.00',
  },
  {
    id: 'SODII-IIIA-(color)-XL',
    desc: 'High Cut Spec Ops Delta Gen II Size: XLarge',
    manu: 'United Shield International',
    price: '$1,380.00',
  },
  {
    id: 'SODII-IIIA-MC-(Size)',
    desc: 'High Cut Spec Ops Delta Gen II - MultiCam. Size: Small, Medium, Large',
    manu: 'United Shield International',
    price: '$1,455.00',
  },
  {
    id: 'SODII-IIIA-MC-XL',
    desc: 'High Cut Spec Ops Delta Gen II - MultiCam. Size: XLarge',
    manu: 'United Shield International',
    price: '$1,510.00',
  },
  {
    id: 'SODIIMC-IIIA-(color)-(Size)',
    desc: 'Mid Cut Spec Ops Delta Gen II Size: Small, Medium, Large',
    manu: 'United Shield International',
    price: '$1,323.00',
  },
  {
    id: 'SODIIMC-IIIA-(color)-XL',
    desc: 'Mid Cut Spec Ops Delta Gen II Size: XLarge',
    manu: 'United Shield International',
    price: '$1,380.00',
  },
  {
    id: 'SODIIMC-IIIA-MC-(Size)',
    desc: 'Mid Cut Spec Ops Delta Gen II - MultiCam. Size: Small, Medium, Large',
    manu: 'United Shield International',
    price: '$1,455.00',
  },
  {
    id: 'SODIIMC-IIIA-MC-XL',
    desc: 'Mid Cut Spec Ops Delta Gen II - MultiCam. Size: XLarge',
    manu: 'United Shield International',
    price: '$1,510.00',
  },
  {
    id: 'SPNT-IIIA-(size)-(color)',
    desc: 'Ultra High Cut Sprint - Size: Small, Medium, Large',
    manu: 'United Shield International',
    price: '$1,196.00',
  },
  {
    id: 'SPNT-IIIA-XL-(color)',
    desc: 'Ultra High Cut Sprint - Size: XLarge',
    manu: 'United Shield International',
    price: '$1,262.00',
  },
  {
    id: 'SPNT-IIIA-MC-(size)',
    desc: 'Ultra High Cut Sprint - MultiCam Size: Small, Medium, Large',
    manu: 'United Shield International',
    price: '$1,328.50',
  },
  {
    id: 'SPNT-IIIA-MC-XL',
    desc: 'Ultra High Cut Sprint - MultiCam Size: XLarge',
    manu: 'United Shield International',
    price: '$1,395.00',
  },
  {
    id: 'SRS-Bump-(color)-S/M',
    desc: 'SRS Bump Helmet. Size: Small/Medium',
    manu: 'United Shield International',
    price: '$630.00',
  },
  {
    id: 'SRS-Bump-(color)-L/XL',
    desc: 'SRS Bump Helmet. Size: Large/XLarge',
    manu: 'United Shield International',
    price: '$630.00',
  },
  {
    id: 'SRS-Bump-MC-S/M',
    desc: 'SRS Bump Helmet-MultiCam Size: Small/Medium',
    manu: 'United Shield International',
    price: '$770.00',
  },
  {
    id: 'SRS-Bump-MC-L/XL',
    desc: 'SRS Bump Helmet-MultiCam Size: Large/XLarge',
    manu: 'United Shield International',
    price: '$770.00',
  },
  {
    id: 'DK5-H.150',
    desc: 'Integrated or retrofit face shield (used with PASGT Helmet) - 8" DK5-H.150 - .150" thick',
    manu: 'United Shield International',
    price: '$167.50',
  },
  {
    id: 'DK5-H.150S',
    desc: 'Integrated or retrofit face shield (used with PASGT Helmet) - 6" DK5-H.150S - .150" thick',
    manu: 'United Shield International',
    price: '$185.00',
  },
  {
    id: 'DK6-H.150',
    desc: 'Retro Fit face shield (used with ACH Mich Helmets) - 8" DK6-H.150 - .150" thick',
    manu: 'United Shield International',
    price: '$185.00',
  },
  {
    id: 'DK6-H.150S',
    desc: 'Retro Fit face shield (used with ACH Mich Helmets) - 6" DK6-H.150s - .150" thick',
    manu: 'United Shield International',
    price: '$208.00',
  },
  {
    id: 'SOD-RFS-Rail',
    desc: 'Retro fit face shield with rail adapters (used on helmets with Rails) - 6" - .150" thick',
    manu: 'United Shield International',
    price: '$247.20',
  },
  {
    id: 'SOD-RFS-Rail-LS',
    desc: 'Retro fit face shield with rail adapters (used on helmets with Rails) - 6" - To include Liquid Seal - .150" thick',
    manu: 'United Shield International',
    price: '$275.00',
  },
  {
    id: 'CTO-DK5-H.150',
    desc: 'Clear Tear Off Protectors 4 Layers of 2 mil Polyester for 8" Face Shields',
    manu: 'United Shield International',
    price: '$52.50',
  },
  {
    id: 'CTO-DK5-H.150S',
    desc: 'Clear Tear Off Protectors 4 Layers of 2 mil Polyester for 6" Face Shields',
    manu: 'United Shield International',
    price: '$52.50',
  },
  {
    id: 'CTO-DK6-H.150',
    desc: 'Clear Tear Off Protectors 4 Layers of 2 mil Polyester for 8" Face Shields',
    manu: 'United Shield International',
    price: '$52.50',
  },
  {
    id: 'CTO-DK6-H.150S',
    desc: 'Clear Tear Off Protectors 4 Layers of 2 mil Polyester for 6" Face Shields',
    manu: 'United Shield International',
    price: '$52.50',
  },
  {
    id: 'CTO-SOD-RFS-Rail',
    desc: 'Clear Tear Off Protectors 4 Layers of 2 mil Polyester for 6" Face Shields - 5-1/2"',
    manu: 'United Shield International',
    price: '$52.50',
  },
  {
    id: 'USI-BOA-(size)',
    desc: 'USI BOA retention system with Rapid Adjustment Dial, installed in USI helmet. Size: S, M, L or XL',
    manu: 'United Shield International',
    price: '$110.50',
  },
  {
    id: 'Alpha-CCS',
    desc: 'Standard 4 Point Harness',
    manu: 'United Shield International',
    price: '$66.50',
  },
  {
    id: 'X-Harness',
    desc: 'Upgraded 4 Point X Harness',
    manu: 'United Shield International',
    price: '$78.00',
  },
  {
    id: 'Omega-Harness',
    desc: 'Omega Mesh Harness system with Omega Chin Cup',
    manu: 'United Shield International',
    price: '$89.00',
  },
  {
    id: 'GMSTRAP',
    desc: 'Gas Mask Extender for USI X harness or USI BOA',
    manu: 'United Shield International',
    price: '$27.00',
  },
  {
    id: 'Combat-pad',
    desc: '4D Combat Pad - 5 Pad Set',
    manu: 'United Shield International',
    price: '$171.00',
  },
  {
    id: 'Rogue-pad',
    desc: '4D Rogue Pad - 9 Pad Set',
    manu: 'United Shield International',
    price: '$171.00',
  },
  {
    id: '4d-7pad',
    desc: '4d 7-Pad Kit',
    manu: 'United Shield International',
    price: '$98.50',
  },
  {
    id: 'ArcRail-(color)',
    desc: 'Side Rail Mounting Kit - 2 Arc Rails, Picatinny adapter and bolts (Black, Tan or  OD Green)',
    manu: 'United Shield International',
    price: '$157.50',
  },
  {
    id: 'Unity-Adapter',
    desc: 'Unity Adapter kit for communications to picatinny attachments-',
    manu: 'United Shield International',
    price: '$157.50',
  },
  {
    id: 'IC-NVG-(color)',
    desc: 'Carbon Fiber NVG mount by Integrated Components (Black, Tan or  OD Green)',
    manu: 'United Shield International',
    price: '$157.50',
  },
  {
    id: 'NVGM-(color)',
    desc: 'Metal Universal NVG Mount (Black, Tan or  OD Green)',
    manu: 'United Shield International',
    price: '$115.50',
  },
  {
    id: 'UNVG-(color)',
    desc: 'Unity SUMMIT NVG Mount',
    manu: 'United Shield International',
    price: '$173.50',
  },
  {
    id: 'WNVG-(color)',
    desc: 'Wilcox NVG Mount',
    manu: 'United Shield International',
    price: '$209.50',
  },
  {
    id: 'CANOPY-BAG',
    desc: 'Premium multiple purpose bag fits helmets and other misc gear',
    manu: 'United Shield International',
    price: '$157.50',
  },
  {
    id: 'H-Bag',
    desc: 'Protective helmet bag with internal foam and zipper',
    manu: 'United Shield International',
    price: '$77.50',
  },
  {
    id: 'Velcro-(color)',
    desc: 'Velcro Kit for Spec Ops Delta Gen II and Spec Ops Rogue (Black, Tan or  OD Green)',
    manu: 'United Shield International',
    price: '$21.00',
  },
  {
    id: 'Hydro-Dip-(color)',
    desc: 'Hydrographic Transfer Pattern for helmet (Multicam, Digital, etc.)',
    manu: 'United Shield International',
    price: '$132.50',
  },
  {
    id: 'RNP',
    desc: 'Nape Pad - Single Piece',
    manu: 'United Shield International',
    price: '$143.50',
  },
  {
    id: 'FNP',
    desc: 'Nape Pad with Fragmentation Protection',
    manu: 'United Shield International',
    price: '$185.00',
  },
  {
    id: 'Cover-Cam',
    desc: 'Helmet Cover - For PASGT and Full Cut / Mid Cut Mich only',
    manu: 'United Shield International',
    price: '$121.50',
  },
  {
    id: 'Cover-Rev',
    desc: 'Helmet Cover - For PASGT and Full Cut / Mid Cut Mich only',
    manu: 'United Shield International',
    price: '$121.50',
  },
  {
    id: 'Gen4-SOD-(size)-(color)',
    desc: 'Helmet Cover for Spec Ops Delta and Spec Ops Delta Mid Cut',
    manu: 'United Shield International',
    price: '$155.00',
  },
  {
    id: 'CWL-(color)',
    desc: 'Cold Weather Liner, one size, fits any helmet',
    manu: 'United Shield International',
    price: '$237.00',
  },
  {
    id: 'STD-18X26-IIIA-INTLSFT-NVP',
    desc: '18" x 26" - No Viewport - 6.2 lbs.',
    manu: 'United Shield International',
    price: '$1,270.00',
  },
  {
    id: 'PT-16X20-IIIA-PLTSFT-NVP',
    desc: '16" x 20" - No Viewport - 3.5 Lbs.',
    manu: 'United Shield International',
    price: '$1,270.00',
  },
  {
    id: 'MC-14X16-IIIA-SFT-NVP',
    desc: '14" x 16" - No Viewport - 2.7 Lbs.',
    manu: 'United Shield International',
    price: '$1,285.00',
  },
  {
    id: 'STD-20X34-IIIA-HH-WVP',
    desc: '20" x 34" - With Viewport, Horizontal Handle - 12.8 lbs.',
    manu: 'United Shield International',
    price: '$2,240.00',
  },
  {
    id: 'STD-20X34-IIIA-ERT-WVP',
    desc: '20" x 34" - With Viewport, ERT Handle - 13.05 lbs.',
    manu: 'United Shield International',
    price: '$2,600.00',
  },
  {
    id: 'STD-24X36-IIIA-HH-WVP',
    desc: '24" x 36" - With Viewport, Horizontal Handle - 16.5 lbs.',
    manu: 'United Shield International',
    price: '$2,580.00',
  },
  {
    id: 'STD-24X36-IIIA-ERT-WVP',
    desc: '24" x 36" - With Viewport, ERT Handle - 16.75 lbs.',
    manu: 'United Shield International',
    price: '$2,940.00',
  },
  {
    id: 'STD-22X40-IIIA-HH-WVP',
    desc: '22" x 40" - With Viewport, Horizontal Handle - 16.9 lbs.',
    manu: 'United Shield International',
    price: '$2,580.00',
  },
  {
    id: 'STD-22X40-IIIA-ERT-WVP',
    desc: '22" x 40" - With Viewport, ERT Handle - 17.15 lbs.',
    manu: 'United Shield International',
    price: '$2,940.00',
  },
  {
    id: 'STD-24X48-IIIA-HH-WVP',
    desc: '24" x 48" - With Viewport, Horizontal Handle - 19.5 lbs.',
    manu: 'United Shield International',
    price: '$3,060.00',
  },
  {
    id: 'STD-24X48-IIIA-ERT-WVP',
    desc: '24" x 48" - With Viewport, ERT Handle - 19.75 lbs.',
    manu: 'United Shield International',
    price: '$3,420.00',
  },
  {
    id: 'STD-24X69-IIIA-HH-WVP',
    desc: '24" x 69" - With Viewport, Horizontal Handle - 26.4 lbs.',
    manu: 'United Shield International',
    price: '$3,780.00',
  },
  {
    id: 'HMLP-IIIA-ELSA-WVP',
    desc: 'HMLP Level IIIA - With Viewport - 12.5 lbs.',
    manu: 'United Shield International',
    price: '$2,600.00',
  },
  {
    id: 'SNIPER-IIIA-NVP',
    desc: '21" x 42" - No Viewport, Sniper Shield - 14 lbs.',
    manu: 'United Shield International',
    price: '$3,700.00',
  },
  {
    id: 'KENT-IIIA-3LSFT-NVP',
    desc: '22" x 32" - No Viewport, Kent Shield - 9.8 lbs.',
    manu: 'United Shield International',
    price: '$2,360.00',
  },
  {
    id: 'ERT-18X30-IIIA-ERT-WVP',
    desc: '18" x 30" - With Viewport, ERT Micra Shield - 12.6 lbs.',
    manu: 'United Shield International',
    price: '$2,600.00',
  },
  {
    id: 'ERT-24X30-IIIA-ERT-WVP',
    desc: '24" x 30" - With Viewport, ERT Mini Shield - 13.75 lbs.',
    manu: 'United Shield International',
    price: '$2,810.00',
  },
  {
    id: 'ERT-24X36-IIIA-ERT-WVP',
    desc: '24" x 36" - With Viewport, ERT Medium Shield - 15.5 lbs.',
    manu: 'United Shield International',
    price: '$2,940.00',
  },
  {
    id: 'ERT-24X48-IIIA-ERT-WVP',
    desc: '24" x 48" - With Viewport, ERT Large Shield - 19.6 lbs.',
    manu: 'United Shield International',
    price: '$3,930.00',
  },
  {
    id: 'ASLT-24X40-IIIA-ASLT-WVP',
    desc: '24" x 40" - With Viewport, Assault Shield, Assault Tri-Grip Handle- 18.25 lbs.',
    manu: 'United Shield International',
    price: '$3,180.00',
  },
  {
    id: 'RRS-21X30-IIIA-ERT-NVP',
    desc: '21" x 30" - No Viewport, Rapid Response Shield - 8.7 lbs.',
    manu: 'United Shield International',
    price: '$2,350.00',
  },
  {
    id: 'RDS-15X27-IIIA-SFT-NVP',
    desc: '15.75" x 27.5" Level IIIA Ballistic Shield, International Soft Handle',
    manu: 'United Shield International',
    price: '$1,630.00',
  },
  {
    id: 'RDS-15X27-IIIA-HH-NVP',
    desc: '15.75" x 27.5" Level IIIA Ballistic Shield, Horizontal Handle',
    manu: 'United Shield International',
    price: '$1,490.00',
  },
  {
    id: 'RDS-15X27-IIIA-ERT-NVP',
    desc: '15.75" x 27.5" Level IIIA Ballistic Shield, ERT Handle',
    manu: 'United Shield International',
    price: '$1,850.00',
  },
  {
    id: 'WSYK-17X29-IIIA-SFT-NVP',
    desc: '17" x 29" (450 mm x 750mm) West York level IIIA Ballistic Shield, International Soft Handle',
    manu: 'United Shield International',
    price: '$2,300.00',
  },
  {
    id: 'DefenderIIIA- Option1-(color)',
    desc: 'Option 1 - car mount, sling - 7 lbs',
    manu: 'United Shield International',
    price: '$1,910.00',
  },
  {
    id: 'DefenderIIIA- Option2-(color)',
    desc: 'Option 2 - car mount, sling, 11"x14" rifle plate (defeats 7.62x51 M80, 5.56x45 62gr M855) - 12 lbs',
    manu: 'United Shield International',
    price: '$3,160.00',
  },
  {
    id: 'DefenderIIIA- Option3-(color)',
    desc: 'Option 3 - car mount, sling, 1100 lumen LED Light - 7.5 lbs',
    manu: 'United Shield International',
    price: '$2,480.00',
  },
  {
    id: 'DefenderIIIA- Option4-(color)',
    desc: 'Option 4 - car mount, sling, 1100 lumen LED light, 11"x14" rifle plate (defeats 7.62x51 M80, 5.56x45 62gr M855) - 12.5 lbs',
    manu: 'United Shield International',
    price: '$3,740.00',
  },
  {
    id: 'STD-20X34-IIIA-HH-MXV',
    desc: '20" x 34" - With MXV Viewport, Horizontal Handle & Arm Pad - 13.45 lbs.',
    manu: 'United Shield International',
    price: '$3,240.00',
  },
  {
    id: 'STD-20X34-IIIA-ERT-MXV',
    desc: '20" x 34" - With MXV Viewport & ERT Handle - 13.7 lbs.',
    manu: 'United Shield International',
    price: '$3,600.00',
  },
  {
    id: 'STD-24X36-IIIA-HH-MXV',
    desc: '24" x 36" - With MXV Viewport, Horizontal Handle & Arm Pad - 17.20 lbs.',
    manu: 'United Shield International',
    price: '$3,470.00',
  },
  {
    id: 'STD-24X36-IIIA-ERT-MXV',
    desc: '24" x 36" - With MXV Viewport & ERT Handle - 17.45 lbs.',
    manu: 'United Shield International',
    price: '$3,830.00',
  },
  {
    id: 'STD-22X40-IIIA-HH-MXV',
    desc: '22" x 40" - With MXV Viewport, Horizontal Handle & Arm Pad - 17.90 lbs.',
    manu: 'United Shield International',
    price: '$3,820.00',
  },
  {
    id: 'STD-22X40-IIIA-ERT-MXV',
    desc: '22" x 40" - With MXV Viewport, ERT Handle - 18.15 lbs.',
    manu: 'United Shield International',
    price: '$4,170.00',
  },
  {
    id: 'RRS-24x36-IIIA-ERT-MXV',
    desc: '24" x 36" - With MXV Viewport & ERT Handle - 15.2 lbs.',
    manu: 'United Shield International',
    price: '$3,620.00',
  },
  {
    id: 'ASLT-20x34-IIIA-ERT-MXV',
    desc: '20" x 34" - With MXV Viewport, Assault Cut outs & ERT Handle - 13.7 lbs.',
    manu: 'United Shield International',
    price: '$3,470.00',
  },
  {
    id: 'ASLT-24x36-IIIA-ERT-MXV',
    desc: '24" x 36" - With MXV Viewport, Assault Cut outs & ERT Handle - 15.5 lbs.',
    manu: 'United Shield International',
    price: '$3,870.00',
  },
  {
    id: 'STD-20X34-LWIIIA-HH-WVP',
    desc: '20" x 34" Lightweight Level IIIA, 4x10 viewport, Horizontal Handle, 10.8 lbs.',
    manu: 'United Shield International',
    price: '$2,590.00',
  },
  {
    id: 'STD-20X34-LWIIIA-ERT-WVP',
    desc: '20" x 34" Lightweight Level IIIA, 4x10 viewport, ERT handle - 11.05 lbs.',
    manu: 'United Shield International',
    price: '$2,950.00',
  },
  {
    id: 'STD-24X36-LWIIIA-HH-WVP',
    desc: '24" x 36" Lightweight Level IIIA, 4x16 viewport, Horizontal Handle - 13.8 lbs.',
    manu: 'United Shield International',
    price: '$2,930.00',
  },
  {
    id: 'STD-24X36-LWIIIA-ERT-WVP',
    desc: '24" x 36" Lightweight Level IIIA, 4x16 viewport, ERT handle - 14.05 lbs.',
    manu: 'United Shield International',
    price: '$3,290.00',
  },
  {
    id: 'STD-22X40-LWIIIA-HH-WVP',
    desc: '22" x 40" Lightweight Level IIIA, 4x16 viewport, Horizontal Handle - 13.9 lbs.',
    manu: 'United Shield International',
    price: '$2,980.00',
  },
  {
    id: 'STD-22X40-LWIIIA-ERT-WVP',
    desc: '22" x 40" Lightweight Level IIIA, 4x16 viewport, ERT handle - 14.24 lbs.',
    manu: 'United Shield International',
    price: '$3,280.00',
  },
  {
    id: 'ERT-18X30-LWIIIA-ERT-WVP',
    desc: '18" x 30" Lightweight Level IIIA, 4x10 viewport, ERT Specialist Shield, ERT handle - 11.25 lbs.',
    manu: 'United Shield International',
    price: '$2,950.00',
  },
  {
    id: 'ERT-24X30-LWIIIA-ERT-WVP',
    desc: '24" x 30" Lightweight Level IIIA, 4x10 viewport, ERT Specialist Shield, ERT handle - 11.90 lbs.',
    manu: 'United Shield International',
    price: '$3,150.00',
  },
  {
    id: 'ERT-24X36-LWIIIA-ERT-WVP',
    desc: '24" x 36" Lightweight Level IIIA, 4x10 viewport, ERT Specialist Shield, ERT handle - 12.5 lbs.',
    manu: 'United Shield International',
    price: '$3,280.00',
  },
  {
    id: 'HMLP-LWIIIA-ELSA-WVP',
    desc: 'Lightweight Level IIIA, Specialist Shield, 4x16 Viewport, HMLP setup - 10.1 lbs.',
    manu: 'United Shield International',
    price: '$2,950.00',
  },
  {
    id: 'KENT-LWIIIA-3LSFT-NVP',
    desc: '22" x 32" - No Viewport, Kent Shield - 7.5 lbs.',
    manu: 'United Shield International',
    price: '$2,590.00',
  },
  {
    id: 'RDS-15X27-LWIIIA-SFT-NVP',
    desc: '15.75" x 27.5" Lightweight IIIA Ballistic Shield, International Soft Handle - 4.8 lbs.',
    manu: 'United Shield International',
    price: '$1,980.00',
  },
  {
    id: 'RDS-15X27-LWIIIA-HH-NVP',
    desc: '15.75" x 27.5" Lightweight IIIA Ballistic Shield, Horizontal Handle',
    manu: 'United Shield International',
    price: '$1,850.00',
  },
  {
    id: 'RDS-15X27-LWIIIA-ERT-NVP',
    desc: '15.75" x 27.5" Lightweight IIIA Ballistic Shield, with Narrow ERT Trip Grip Handle',
    manu: 'United Shield International',
    price: '$2,200.00',
  },
  {
    id: 'RRS-21X30-LWIIIA-ERT-NVP',
    desc: '21" x 30" - No Viewport, Rapid Response Shield - 8.4 lbs',
    manu: 'United Shield International',
    price: '$2,700.00',
  },
  {
    id: 'WSYK-17X29-LWIIIA-SFT-NVP',
    desc: '17" x 29" West York Lightweight IIIA Ballistic Shield, international soft handle - 5.5 lbs.',
    manu: 'United Shield International',
    price: '$2,650.00',
  },
  {
    id: 'STD-20X34-LWIIIA-HH-MXV',
    desc: '20" x 34" Lightweight Level IIIA, MXV, Horizontal handle, Arm Pad - 11.4 lbs.',
    manu: 'United Shield International',
    price: '$3,590.00',
  },
  {
    id: 'STD-20X34-LWIIIA-ERT-MXV',
    desc: '20" x 34" Lightweight Level IIIA, MXV, ERT handle - 11.6 lbs.',
    manu: 'United Shield International',
    price: '$3,950.00',
  },
  {
    id: 'STD-24X36-LWIIIA-HH-MXV',
    desc: '24" x 36" Lightweight Level IIIA, MXV, Horizontal handle, Arm Pad - 14.2 lbs.',
    manu: 'United Shield International',
    price: '$3,820.00',
  },
  {
    id: 'STD-24X36-LWIIIA-ERT-MXV',
    desc: '24" x 36" Lightweight Level IIIA, MXV, ERT handle - 14.4 lbs.',
    manu: 'United Shield International',
    price: '$4,180.00',
  },
  {
    id: 'STD-22X40-LWIIIA-HH-MXV',
    desc: '22" x 40" Lightweight Level IIIA, MXV, Horizontal handle, arm pad - 14.4 lbs.',
    manu: 'United Shield International',
    price: '$3,820.00',
  },
  {
    id: 'STD-22X40-LWIIIA-ERT-MXV',
    desc: '22" x 40" Lightweight Level IIIA, MXV, ERT handle - 14.6 lbs.',
    manu: 'United Shield International',
    price: '$4,180.00',
  },
  {
    id: 'STD-24X48-LWIIIA-HH-MXV',
    desc: '24" x 48" Lightweight Level IIIA, MXV, Horizontal handle, Arm Pad - 16.5 lbs.',
    manu: 'United Shield International',
    price: '$3,860.00',
  },
  {
    id: 'STD-24X48-LWIIIA-ERT-MXV',
    desc: '24" x 48" Lightweight Level IIIA, MXV, ERT handle - 16.7 lbs.',
    manu: 'United Shield International',
    price: '$4,220.00',
  },
  {
    id: 'DefenderIIIA- Option1-(color)',
    desc: 'Option 1 - car mount, sling - 7 lbs',
    manu: 'United Shield International',
    price: '$1,910.00',
  },
  {
    id: 'DefenderIIIA- Option2-(color)',
    desc: 'Option 2 - car mount, sling, 11"x14" rifle plate (defeats 7.62x51 M80, 5.56x45 62gr M855) - 12 lbs',
    manu: 'United Shield International',
    price: '$3,160.00',
  },
  {
    id: 'DefenderIIIA- Option3-(color)',
    desc: 'Option 3 - car mount, sling, 1100 lumen LED Light - 7.5 lbs',
    manu: 'United Shield International',
    price: '$2,480.00',
  },
  {
    id: 'DefenderIIIA- Option4-(color)',
    desc: 'Option 4 - car mount, sling, 1100 lumen LED light, 11"x14" rifle plate (defeats 7.62x51 M80, 5.56x45 62gr M855) - 12.5 lbs',
    manu: 'United Shield International',
    price: '$3,740.00',
  },
  {
    id: 'STD-20X34-IIIA-HH-MXV',
    desc: '20" x 34" - With MXV Viewport, Horizontal Handle & Arm Pad - 13.45 lbs.',
    manu: 'United Shield International',
    price: '$3,240.00',
  },
  {
    id: 'STD-20X34-IIIA-ERT-MXV',
    desc: '20" x 34" - With MXV Viewport & ERT Handle - 13.7 lbs.',
    manu: 'United Shield International',
    price: '$3,600.00',
  },
  {
    id: 'STD-24X36-IIIA-HH-MXV',
    desc: '24" x 36" - With MXV Viewport, Horizontal Handle & Arm Pad - 17.20 lbs.',
    manu: 'United Shield International',
    price: '$3,470.00',
  },
  {
    id: 'STD-24X36-IIIA-ERT-MXV',
    desc: '24" x 36" - With MXV Viewport & ERT Handle - 17.45 lbs.',
    manu: 'United Shield International',
    price: '$3,830.00',
  },
  {
    id: 'STD-22X40-IIIA-HH-MXV',
    desc: '22" x 40" - With MXV Viewport, Horizontal Handle & Arm Pad - 17.90 lbs.',
    manu: 'United Shield International',
    price: '$3,820.00',
  },
  {
    id: 'STD-22X40-IIIA-ERT-MXV',
    desc: '22" x 40" - With MXV Viewport, ERT Handle - 18.15 lbs.',
    manu: 'United Shield International',
    price: '$4,170.00',
  },
  {
    id: 'RRS-24x36-IIIA-ERT-MXV',
    desc: '24" x 36" - With MXV Viewport & ERT Handle - 15.2 lbs.',
    manu: 'United Shield International',
    price: '$3,620.00',
  },
  {
    id: 'ASLT-20x34-IIIA-ERT-MXV',
    desc: '20" x 34" - With MXV Viewport, Assault Cut outs & ERT Handle - 13.7 lbs.',
    manu: 'United Shield International',
    price: '$3,470.00',
  },
  {
    id: 'ASLT-24x36-IIIA-ERT-MXV',
    desc: '24" x 36" - With MXV Viewport, Assault Cut outs & ERT Handle - 15.5 lbs.',
    manu: 'United Shield International',
    price: '$3,870.00',
  },
  {
    id: 'STD-20X34-LWIIIA-HH-WVP',
    desc: '20" x 34" Lightweight Level IIIA, 4x10 viewport, Horizontal Handle, 10.8 lbs.',
    manu: 'United Shield International',
    price: '$2,590.00',
  },
  {
    id: 'STD-20X34-LWIIIA-ERT-WVP',
    desc: '20" x 34" Lightweight Level IIIA, 4x10 viewport, ERT handle - 11.05 lbs.',
    manu: 'United Shield International',
    price: '$2,950.00',
  },
  {
    id: 'STD-24X36-LWIIIA-HH-WVP',
    desc: '24" x 36" Lightweight Level IIIA, 4x16 viewport, Horizontal Handle - 13.8 lbs.',
    manu: 'United Shield International',
    price: '$2,930.00',
  },
  {
    id: 'STD-24X36-LWIIIA-ERT-WVP',
    desc: '24" x 36" Lightweight Level IIIA, 4x16 viewport, ERT handle - 14.05 lbs.',
    manu: 'United Shield International',
    price: '$3,290.00',
  },
  {
    id: 'STD-22X40-LWIIIA-HH-WVP',
    desc: '22" x 40" Lightweight Level IIIA, 4x16 viewport, Horizontal Handle - 13.9 lbs.',
    manu: 'United Shield International',
    price: '$2,980.00',
  },
  {
    id: 'STD-22X40-LWIIIA-ERT-WVP',
    desc: '22" x 40" Lightweight Level IIIA, 4x16 viewport, ERT handle - 14.24 lbs.',
    manu: 'United Shield International',
    price: '$3,280.00',
  },
  {
    id: 'ERT-18X30-LWIIIA-ERT-WVP',
    desc: '18" x 30" Lightweight Level IIIA, 4x10 viewport, ERT Specialist Shield, ERT handle - 11.25 lbs.',
    manu: 'United Shield International',
    price: '$2,950.00',
  },
  {
    id: 'ERT-24X30-LWIIIA-ERT-WVP',
    desc: '24" x 30" Lightweight Level IIIA, 4x10 viewport, ERT Specialist Shield, ERT handle - 11.90 lbs.',
    manu: 'United Shield International',
    price: '$3,150.00',
  },
  {
    id: 'ERT-24X36-LWIIIA-ERT-WVP',
    desc: '24" x 36" Lightweight Level IIIA, 4x10 viewport, ERT Specialist Shield, ERT handle - 12.5 lbs.',
    manu: 'United Shield International',
    price: '$3,280.00',
  },
  {
    id: 'HMLP-LWIIIA-ELSA-WVP',
    desc: 'Lightweight Level IIIA, Specialist Shield, 4x16 Viewport, HMLP setup - 10.1 lbs.',
    manu: 'United Shield International',
    price: '$2,950.00',
  },
  {
    id: 'KENT-LWIIIA-3LSFT-NVP',
    desc: '22" x 32" - No Viewport, Kent Shield - 7.5 lbs.',
    manu: 'United Shield International',
    price: '$2,590.00',
  },
  {
    id: 'RDS-15X27-LWIIIA-SFT-NVP',
    desc: '15.75" x 27.5" Lightweight IIIA Ballistic Shield, International Soft Handle - 4.8 lbs.',
    manu: 'United Shield International',
    price: '$1,980.00',
  },
  {
    id: 'RDS-15X27-LWIIIA-HH-NVP',
    desc: '15.75" x 27.5" Lightweight IIIA Ballistic Shield, Horizontal Handle',
    manu: 'United Shield International',
    price: '$1,850.00',
  },
  {
    id: 'RDS-15X27-LWIIIA-ERT-NVP',
    desc: '15.75" x 27.5" Lightweight IIIA Ballistic Shield, with Narrow ERT Trip Grip Handle',
    manu: 'United Shield International',
    price: '$2,200.00',
  },
  {
    id: 'RRS-21X30-LWIIIA-ERT-NVP',
    desc: '21" x 30" - No Viewport, Rapid Response Shield - 8.4 lbs',
    manu: 'United Shield International',
    price: '$2,700.00',
  },
  {
    id: 'WSYK-17X29-LWIIIA-SFT-NVP',
    desc: '17" x 29" West York Lightweight IIIA Ballistic Shield, international soft handle - 5.5 lbs.',
    manu: 'United Shield International',
    price: '$2,650.00',
  },
  {
    id: 'STD-20X34-LWIIIA-HH-MXV',
    desc: '20" x 34" Lightweight Level IIIA, MXV, Horizontal handle, Arm Pad - 11.4 lbs.',
    manu: 'United Shield International',
    price: '$3,590.00',
  },
  {
    id: 'STD-20X34-LWIIIA-ERT-MXV',
    desc: '20" x 34" Lightweight Level IIIA, MXV, ERT handle - 11.6 lbs.',
    manu: 'United Shield International',
    price: '$3,950.00',
  },
  {
    id: 'STD-24X36-LWIIIA-HH-MXV',
    desc: '24" x 36" Lightweight Level IIIA, MXV, Horizontal handle, Arm Pad - 14.2 lbs.',
    manu: 'United Shield International',
    price: '$3,820.00',
  },
  {
    id: 'STD-24X36-LWIIIA-ERT-MXV',
    desc: '24" x 36" Lightweight Level IIIA, MXV, ERT handle - 14.4 lbs.',
    manu: 'United Shield International',
    price: '$4,180.00',
  },
  {
    id: 'STD-22X40-LWIIIA-HH-MXV',
    desc: '22" x 40" Lightweight Level IIIA, MXV, Horizontal handle, arm pad - 14.4 lbs.',
    manu: 'United Shield International',
    price: '$3,820.00',
  },
  {
    id: 'STD-22X40-LWIIIA-ERT-MXV',
    desc: '22" x 40" Lightweight Level IIIA, MXV, ERT handle - 14.6 lbs.',
    manu: 'United Shield International',
    price: '$4,180.00',
  },
  {
    id: 'STD-24X48-LWIIIA-HH-MXV',
    desc: '24" x 48" Lightweight Level IIIA, MXV, Horizontal handle, Arm Pad - 16.5 lbs.',
    manu: 'United Shield International',
    price: '$3,860.00',
  },
  {
    id: 'STD-24X48-LWIIIA-ERT-MXV',
    desc: '24" x 48" Lightweight Level IIIA, MXV, ERT handle - 16.7 lbs.',
    manu: 'United Shield International',
    price: '$4,220.00',
  },
  {
    id: 'RRS-24X36-LWIIIA-ERT-MXV',
    desc: '24" x 36" Lightweight Level IIIA, RRS Specialist shield, ERT handle - 13.2 lbs.',
    manu: 'United Shield International',
    price: '$3,940.00',
  },
  {
    id: 'ASLT-20X34-LWIIIA-ERT-MXV',
    desc: '20" x 34" Lightweight Level IIIA, Specialist shield with assault cut outs, ERT handle - 11.2 lbs.',
    manu: 'United Shield International',
    price: '$3,820.00',
  },
  {
    id: 'ASLT-24X36-LWIIIA-ERT-MXV',
    desc: '24" x 36" Lightweight Level IIIA, Specialist shield with assault cut outs, ERT handle - 14.9 lbs.',
    manu: 'United Shield International',
    price: '$4,220.00',
  },
  {
    id: 'ASLT-24X36-LWIIIA-ASLT-MXV',
    desc: '24" x 36" Lightweight Level IIIA, Specialist shield with assault cut outs, Assault handle - 14.7 lbs.',
    manu: 'United Shield International',
    price: '$4,280.00',
  },
  {
    id: 'EXPRO-III+LW-(vehicle type)',
    desc: '3 Flat Panels, Executive Protection, attaches to rear seats of SUV (available for Chevy/Ford/GMC), approx. weight 25.3 lbs.',
    manu: 'United Shield International',
    price: '$12,290.00',
  },
  {
    id: 'EVO-18x32-PHTM-HH-WVP',
    desc: '18" x 32" With Viewport, Horizontal Handle, Rifle Shield Level III+ (RF1), Ultra Lightweight 14.6 lbs, Padded Shield Bag included',
    manu: 'United Shield International',
    price: '$14,680.00',
  },
  {
    id: 'EVO-18x32-PHTM-ERT-WVP',
    desc: '18" x 32" With Viewport, ERT TriGrip Handle, Rifle Shield Level III+(RF1), Ultra Lightweight 17.45 lbs, Padded Shield Bag included',
    manu: 'United Shield International',
    price: '$15,030.00',
  },
  {
    id: 'EVO-18x32-PHTM-HH-NVP',
    desc: '18" x 32" No Viewport, Horizontal Handle, Rifle Shield Level III+(RF1), Ultra Lightweight 10.35 lbs, Padded Shield Bag included',
    manu: 'United Shield International',
    price: '$13,000.00',
  },
  {
    id: 'EVO-18x32-PHTM-ERT-NVP',
    desc: '18" x 32" No Viewport, ERT TriGrip Handle, Rifle Shield Level III+(RF1), Ultra Lightweight 12.95 lbs, Padded Shield Bag included',
    manu: 'United Shield International',
    price: '$13,350.00',
  },
  {
    id: 'STD-20x34-PHTM-HH-WVP',
    desc: '20" x 34" With Viewport, Horizontal Handle, Rifle Shield Level III+(RF1), Ultra Lightweight 18.8 lbs, Padded Shield Bag included',
    manu: 'United Shield International',
    price: '$17,270.00',
  },
  {
    id: 'STD-20x34-PHTM-ERT-WVP',
    desc: '20" x 34" With Viewport, ERT TriGrip Handle, Rifle Shield Level III+(RF1), Ultra Lightweight 20.95 lbs, Padded Shield Bag included',
    manu: 'United Shield International',
    price: '$17,610.00',
  },
  {
    id: 'STD-20x34-PHTM-HH-NVP',
    desc: '20" x 34" No Viewport, Horizontal Handle, Rifle Shield Level III+(RF1), Ultra Lightweight 14.3 lbs, Padded Shield Bag included',
    manu: 'United Shield International',
    price: '$15,590.00',
  },
  {
    id: 'STD-20x34-PHTM-ERT-NVP',
    desc: '20" x 34" No Viewport, ERT TriGrip Handle, Rifle Shield Level III+(RF1), Ultra Lightweight 16.45 lbs, Padded Shield Bag included',
    manu: 'United Shield International',
    price: '$15,930.00',
  },
  {
    id: 'STD-24x48-PHTM-HH-WVP',
    desc: '24" x 48" With Viewport, Horizontal Handle, Rifle Shield Level III+(RF1), Ultra Lightweight 26.7 lbs, Padded Shield Bag included',
    manu: 'United Shield International',
    price: '$24,500.00',
  },
  {
    id: 'STD-24x48-PHTM-ERT-WVP',
    desc: '24" x 48" With Viewport, ERT TriGrip Handle, Rifle Shield Level III+(RF1), Ultra Lightweight 27.7 lbs, Padded Shield Bag included',
    manu: 'United Shield International',
    price: '$24,840.00',
  },
  {
    id: 'STD-24x48-PHTM-HH-NVP',
    desc: '24" x 48" No Viewport, Horizontal Handle, Rifle Shield Level III+(RF1), Ultra Lightweight 22.2 lbs, Padded Shield Bag included',
    manu: 'United Shield International',
    price: '$22,820.00',
  },
  {
    id: 'STD-24x48-PHTM-ERT-NVP',
    desc: '24" x 48" No Viewport, ERT TriGrip Handle, Rifle Shield Level III+(RF1), Ultra Lightweight 23.2 lbs, Padded Shield Bag included',
    manu: 'United Shield International',
    price: '$23,160.00',
  },
  {
    id: 'RDS-15X27-III++LW-SFT-NVP',
    desc: '15.75" x 27.5" RDS, LW III++, with International Soft Handle, 22lbs.',
    manu: 'United Shield International',
    price: '$6,800.00',
  },
  {
    id: 'STD-21X36-LWIII++-HH-WVP',
    desc: '21" x 36" With viewport, Horizontal Handle, Rifle Shield Level III++, 35.5 lbs.',
    manu: 'United Shield International',
    price: '$18,500.00',
  },
  {
    id: 'STD-21X36-LWIII++-ERT-WVP',
    desc: '21" x 36" With viewport, ERT Handle, Rifle Shield Level III++, 35.5 lbs.',
    manu: 'United Shield International',
    price: '$18,840.00',
  },
  {
    id: 'STD-21X36-LWIII++-HH-NVP',
    desc: '21" x 36" No viewport, Horizontal Handle, Rifle Shield Level III++, 33.8 lbs.',
    manu: 'United Shield International',
    price: '$17,100.00',
  },
  {
    id: 'STD-21X36-LWIII++-ERT-NVP',
    desc: '21" x 36" No viewport, ERT Handle, Rifle Shield Level III++, 33.8 lbs.',
    manu: 'United Shield International',
    price: '$17,450.00',
  },
  {
    id: 'TWSP-20X60-III+LW-TW-WVP',
    desc: '(1) 20" x 60" Lightweight III+ Flat Shield, Specialty Tri-Wing Handle, Flat Viewport',
    manu: 'United Shield International',
    price: '$17,230.00',
  },
  {
    id: 'TWSP-20X60-III+LW-TW-WVP-TRLY',
    desc: '(1) 20" x 60" Lightweight III+ Flat Shield, Specialty Tri-Wing Handle, Flat Viewport with trolley',
    manu: 'United Shield International',
    price: '$26,550.00',
  },
  {
    id: 'TWFS-3-20X60-III+LW-TW-WVP-TRLY',
    desc: '(1) 20" x 60" Lightweight III+ Flat shield, (2) LW III+ Wing Shields, Specialty Tri-Wing Handle, Flat Viewport on center panel',
    manu: 'United Shield International',
    price: '$55,540.00',
  },
  {
    id: 'TWSP-20X60-III+LW-TW-NVP',
    desc: '(1) 20" x 60" Lightweight III+ Flat Shield, Specialty Tri-Wing Handle, No Viewport',
    manu: 'United Shield International',
    price: '$13,850.00',
  },
  {
    id: 'TWSP-20X60-III+LW-TW-NVP-TRLY',
    desc: '(1) 20" x 60" Lightweight III+ Flat Shield, Specialty Tri-Wing Handle, No Viewport with trolley',
    manu: 'United Shield International',
    price: '$23,170.00',
  },
  {
    id: 'TWFS-3-20X60-III+LW-TW-NVP-TRLY',
    desc: '(1) 20" x 60" Lightweight III+ Flat shield, (2) LW III+ Wing Shields, Specialty Tri-Wing Handle, No viewports',
    manu: 'United Shield International',
    price: '$52,100.00',
  },
  {
    id: 'STD-20X34-IV-HH-WVP',
    desc: '20" x 34" Flat With Viewport, Rifle Shields Level IV, 60 Lbs. (Trolley strongly suggested due to weight)',
    manu: 'United Shield International',
    price: '$11,570.00',
  },
  {
    id: 'STD-24X36-IV-HH-WVP',
    desc: '24" X 36" Flat With Viewport, Rifle Shields Level IV, 72 Lbs. (Trolley strongly suggested due to weight)',
    manu: 'United Shield International',
    price: '$13,080.00',
  },
  {
    id: 'STD-24X48-IV-HH-WVP',
    desc: '24" x 48" Flat With Viewport, Rifle Shields Level IV, 95 Lbs. (Trolley strongly suggested due to weight)',
    manu: 'United Shield International',
    price: '$14,470.00',
  },
  {
    id: 'TROLLEY',
    desc: 'Carrying System',
    manu: 'United Shield International',
    price: '$1,910.00',
  },
  {
    id: 'CTO-MXV',
    desc: 'Clear Tear Off Protectors 4 Layers of 2 mil Polyester for MXV Viewport',
    manu: 'United Shield International',
    price: '$52.50',
  },
  {
    id: 'Logo-(desired word)-(adhesive)',
    desc: 'Adhesive Letters for front of Shield (Standard option for all IIIA & LW IIIA)',
    manu: 'United Shield International',
    price: '$55.50',
  },
  {
    id: 'Logo-(desired word)-(Velcro)',
    desc: 'Velcro Letters for front of Shield (Standard option for all LW III+)',
    manu: 'United Shield International',
    price: '$55.50',
  },
  {
    id: 'SCMM',
    desc: 'Retrofit Camera Mount for front of shield - 2 rows of molle for camera attachment',
    manu: 'United Shield International',
    price: '$100.00',
  },
  {
    id: 'SCMS',
    desc: 'Retrofit Camera Mount for front of shield - Slick front',
    manu: 'United Shield International',
    price: '$100.00',
  },
  {
    id: 'ERT-Handle',
    desc: 'Upgrade ERT Handle on Standard Shields - Shield must be 20" wide to accept ERT handle',
    manu: 'United Shield International',
    price: '$342.00',
  },
  {
    id: 'SHOULDER STRAP',
    desc: 'Shoulder strap for shields-Retro fit or Direct mount',
    manu: 'United Shield International',
    price: '$100.00',
  },
  {
    id: 'Hook',
    desc: 'Shield Hook',
    manu: 'United Shield International',
    price: '$165.50',
  },
  {
    id: 'ForearmPad',
    desc: 'Forearm Pad - attaches to inside shield with Hook Loop',
    manu: 'United Shield International',
    price: '$33.50',
  },
  {
    id: 'ZSP',
    desc: 'Zippered Pouch, Velcro Backed for extra batteries',
    manu: 'United Shield International',
    price: '$45.00',
  },
  {
    id: 'LED-B30',
    desc: 'LED LIGHTS (1000 LUMENS)',
    manu: 'United Shield International',
    price: '$1,102.50',
  },
  {
    id: 'LED-B50',
    desc: 'LED LIGHTS (1000 LUMENS)',
    manu: 'United Shield International',
    price: '$882.00',
  },
  {
    id: 'ASLT-LED',
    desc: 'Led Light (1200 Lumens) with Assault Handle - batteries integrated into handle',
    manu: 'United Shield International',
    price: '$1,580.00',
  },
  {
    id: 'DD-LED',
    desc: 'Led Light (1200 Lumens) with Assault "Horizontal Handle" only - batteries integrated into handle',
    manu: 'United Shield International',
    price: '$1,323.00',
  },
  {
    id: 'SPECTER-LED-(Flat or Curved)',
    desc: 'Specter Gen II Wireless LED Light (5000 lumens), includes LED module, base plate, pressure pad and remote switch. Factory installed or retro-fit.',
    manu: 'United Shield International',
    price: '$1,417.50',
  },
  {
    id: 'SPECTER-BP-(Flat or Curved)',
    desc: 'Specter Gen II Wireless LED (base plate only).',
    manu: 'United Shield International',
    price: '$120.00',
  },
  {
    id: 'Specter-CC',
    desc: 'Specter Gen II Clear Protective Cover',
    manu: 'United Shield International',
    price: '$100.00',
  },
  {
    id: 'W7K-LED-C',
    desc: 'Wireless LED Light (7000 Lumens) - Curved',
    manu: 'United Shield International',
    price: '$1,260.00',
  },
  {
    id: 'W7K-LED-F',
    desc: 'Wireless LED Light (7000 Lumens) - Flat',
    manu: 'United Shield International',
    price: '$1,260.00',
  },
  {
    id: '11x21-LWIII+UPG',
    desc: '11" x 21" Light Weight Level III+ upgrade panel for Level IIIA Shields - 4.7 lbs.',
    manu: 'United Shield International',
    price: '$2,811.50',
  },
  {
    id: 'WestYorks-LWIII+UPG',
    desc: '12" x 16.5" Light Weight Level III+ upgrade panel for West Yorks LW Level IIIA Shields',
    manu: 'United Shield International',
    price: '$2,371.00',
  },
  {
    id: 'BS-2',
    desc: '20" x 36" x .150" - 6 Lbs.',
    manu: 'United Shield International',
    price: '$300.00',
  },
  {
    id: 'BS-3',
    desc: '24" x 48" x .150" - 8.5 Lbs.',
    manu: 'United Shield International',
    price: '$335.00',
  },
  {
    id: 'CS-4',
    desc: '24" x 48" x .150" - 7 Lbs.',
    manu: 'United Shield International',
    price: '$335.00',
  },
  {
    id: 'BS-9',
    desc: '24" x 48" x .250", 14 Lbs.',
    manu: 'United Shield International',
    price: '$538.00',
  },
  {
    id: 'BS-7',
    desc: '24" x .150" Round - 4.75 lbs.',
    manu: 'United Shield International',
    price: '$335.00',
  },
  {
    id: 'ShldCvr-(size)',
    desc: 'Shield Cover for top half of Shield to protect front and rear of viewport',
    manu: 'United Shield International',
    price: '$100.00',
  },
  {
    id: 'CB-RDS',
    desc: '15.75" x 27.5" Padded Carry Bag for RDS Shield',
    manu: 'United Shield International',
    price: '$130.00',
  },
  {
    id: 'CB-SM',
    desc: '20" x 34" Padded Shield Carry Bag',
    manu: 'United Shield International',
    price: '$155.00',
  },
  {
    id: 'CB-STD',
    desc: '24" x 36" Padded Shield Carry Bag',
    manu: 'United Shield International',
    price: '$180.00',
  },
  {
    id: 'CB-MED',
    desc: '22" x 40" Padded Shield Carry Bag',
    manu: 'United Shield International',
    price: '$190.00',
  },
  {
    id: 'CB-LG',
    desc: '24" x 51" Padded Shield Carry Bag',
    manu: 'United Shield International',
    price: '$240.00',
  },
  {
    id: 'CB-GR',
    desc: '24" x 69" Padded Shield Carry Bag',
    manu: 'United Shield International',
    price: '$277.00',
  },
  {
    id: 'TROLLEY',
    desc: 'Carrying System',
    manu: 'United Shield International',
    price: '$1,910.00',
  },
  {
    id: 'Acer-Lite-GenII-10x12',
    desc: '10 x 12 Acer Lite GenII Level III+ Steel Rifle Plate - 6.4 lbs.',
    manu: 'United Shield International',
    price: '$270.00',
  },
  {
    id: 'Acer-Lite-GenII-8x10',
    desc: '8 x 10 Acer Lite GenII Level III+ Steel Rifle Plate',
    manu: 'United Shield International',
    price: '$253.00',
  },
  {
    id: 'Acer-Lite-GenII-6x6',
    desc: '6 x 6 Acer Lite GenII Level III+ Steel Rifle Plate',
    manu: 'United Shield International',
    price: '$193.00',
  },
  {
    id: 'USIPL-1100-10x12',
    desc: '10 x 12 SA Level III+ Plate, 3.0 lbs.',
    manu: 'United Shield International',
    price: '$1,014.30',
  },
  {
    id: 'USIPL-1100-8x10',
    desc: '8 x 10 SA Level III+ Plate, 2.1 lbs.',
    manu: 'United Shield International',
    price: '$865.46',
  },
  {
    id: 'USIPL-1100-6x6',
    desc: '6 x 6 SA Level III+ Plate, 1.1 lbs',
    manu: 'United Shield International',
    price: '$567.00',
  },
  {
    id: 'USIICPL-1150-10x12',
    desc: '10 x 12 Inconjunction Level III+ Plate, 2.1 lbs.',
    manu: 'United Shield International',
    price: '$1,071.00',
  },
  {
    id: 'USIICPL-1150-8x10',
    desc: '8 x 10 Inconjunction Level III+ Plate, 1.47 lbs.',
    manu: 'United Shield International',
    price: '$787.50',
  },
  {
    id: 'USIICPL-1150-7x9',
    desc: '7 x 9 Inconjunction Level III+ Plate, 1.20 lbs.',
    manu: 'United Shield International',
    price: '$661.50',
  },
  {
    id: 'USIICPL-1150-6x8',
    desc: '6 x 8 Inconjunction Level III+ Plate, 0.95 lbs.',
    manu: 'United Shield International',
    price: '$546.00',
  },
  {
    id: 'USIICPL-1150-7x9-F',
    desc: '7 x 9 Inconjunction Level III+ Plate, 1.20 lbs. Female Curved',
    manu: 'United Shield International',
    price: '$661.50',
  },
  {
    id: 'USIICPL-1150-6x8-F',
    desc: '6 x 8 Inconjunction Level III+ Plate, 0.95 lbs. Female Curved',
    manu: 'United Shield International',
    price: '$546.00',
  },
  {
    id: 'USIICPL-1150-5x8',
    desc: '5 x 8 Inconjunction Level III+ Plate, 0.79 lbs',
    manu: 'United Shield International',
    price: '$472.50',
  },
  {
    id: 'USIICPL-1150-XS',
    desc: '7.25" x 11.5" - Inconjunction Level III+ Plate, 1.6 lbs',
    manu: 'United Shield International',
    price: '$920.00',
  },
  {
    id: 'USIICPL-1150-SM',
    desc: '8.75" x 11.75" Inconjunction Level III+ Plate, 1.9 lbs',
    manu: 'United Shield International',
    price: '$990.00',
  },
  {
    id: 'USIICPL-1150-MD',
    desc: '9.5" x 12.5" Inconjunction Level III+ Plate, 2.2 lbs',
    manu: 'United Shield International',
    price: '$1,050.00',
  },
  {
    id: 'USIICPL-1150-LG',
    desc: '10.25" x 13.25" Inconjunction Level III+ Plate, 2.5 lbs',
    manu: 'United Shield International',
    price: '$1,300.00',
  },
  {
    id: 'USIICPL-1150-XL',
    desc: '11" x 14" Inconjunction Level III+ Plate, 2.8 lbs',
    manu: 'United Shield International',
    price: '$1,400.00',
  },
  {
    id: 'USIPL-2200-10x12',
    desc: '10 x 12 Inconjunction Level III+ Plate, 3.8 lbs.',
    manu: 'United Shield International',
    price: '$542.50',
  },
  {
    id: 'USIPL-2200-8x10',
    desc: '8 x 10 Inconjunction Level III+ Plate, 3.4 lbs.',
    manu: 'United Shield International',
    price: '$511.50',
  },
  {
    id: 'USIPL-2100-10x12',
    desc: '10 x 12 Special Threat Plate, 5.6 lbs.',
    manu: 'United Shield International',
    price: '$727.65',
  },
  {
    id: 'USIPL-2100-8x10',
    desc: '8 x 10 Special Threat Plate, 3.5 lbs.',
    manu: 'United Shield International',
    price: '$606.38',
  },
  {
    id: 'USIPL-2100-6x6',
    desc: '6 x 6 Special Threat Plate, 1.9 lbs.',
    manu: 'United Shield International',
    price: '$507.15',
  },
  {
    id: 'USISTPL-2750-XS',
    desc: '7.25" x 11.5" - Stand Alone Special Threat Plate, 2.2 lbs',
    manu: 'United Shield International',
    price: '$990.00',
  },
  {
    id: 'USISTPL-2750-SM',
    desc: '8.75" x 11.75"  Stand Alone Special Threat Plate, 2.9 lbs',
    manu: 'United Shield International',
    price: '$1,050.00',
  },
  {
    id: 'USISTPL-2750-MD',
    desc: '9.5" x 12.5"  Stand Alone Special Threat Plate, 3.3 lbs',
    manu: 'United Shield International',
    price: '$1,150.00',
  },
  {
    id: 'USISTPL-2750-LG',
    desc: '10.25" x 13.25"  Stand Alone Special Threat Plate, 3.9 lbs',
    manu: 'United Shield International',
    price: '$1,250.00',
  },
  {
    id: 'USISTPL-2750-XL',
    desc: '11" x 14"  Stand Alone Special Threat Plate, 4.5lbs',
    manu: 'United Shield International',
    price: '$1,400.00',
  },
  {
    id: 'USISTPL-2750-6x6',
    desc: '6" x 6"  Stand Alone Special Threat Plate, 1.0 lbs',
    manu: 'United Shield International',
    price: '$510.00',
  },
  {
    id: 'USIPL-3100-10x12',
    desc: '10 x 12 Ascend SA Level IV plate, 7.8 lbs.',
    manu: 'United Shield International',
    price: '$360.00',
  },
  {
    id: 'USIPL-3100-8x10',
    desc: '8 x 10 Ascend SA Level IV plate, 4.9 lbs.',
    manu: 'United Shield International',
    price: '$341.00',
  },
  {
    id: 'USIPL-3100-6x8',
    desc: '6 x 8 Ascend SA Level IV plate, 3.3 lbs.',
    manu: 'United Shield International',
    price: '$266.00',
  },
  {
    id: 'APL- RF1-100-10x12',
    desc: '10 x 12 APL Level III Plate, 3.3 lbs.',
    manu: 'United Shield International',
    price: '$771.75',
  },
  {
    id: 'APL- RF1-100-8x10',
    desc: '8 x 10 APL Level III Plate, 2.3 lbs.',
    manu: 'United Shield International',
    price: '$577.50',
  },
  {
    id: 'APL- RF1-100-6x6',
    desc: '6 x 6 APL Level III Plate, 1.04 lbs.',
    manu: 'United Shield International',
    price: '$367.50',
  },
  {
    id: 'APL- RF1-150-10x12',
    desc: '10 x 12 APL Level III Plate, 3.3 lbs. - Tested and compliant to NIJ 0101.07',
    manu: 'United Shield International',
    price: '$670.00',
  },
  {
    id: 'APL- RF1-150-8x10',
    desc: '8 x 10 APL Level III Plate, 2.3 lbs.. - Tested and compliant to NIJ 0101.07',
    manu: 'United Shield International',
    price: '$530.00',
  },
  {
    id: 'APL- RF1-300-10x12',
    desc: '10 x 12 APL Level III Plate, 2.2 lbs.',
    manu: 'United Shield International',
    price: '$1,200.00',
  },
  {
    id: 'APL- RF1-300-8x10',
    desc: '8 x 10 APL Level III Plate, 1.4 lbs.',
    manu: 'United Shield International',
    price: '$1,150.00',
  },
  {
    id: 'APL- RF1-300-6x6',
    desc: '6 x 6 APL Level III Plat , 1.01 lbs.',
    manu: 'United Shield International',
    price: '$320.00',
  },
  {
    id: 'APL- RF2-200-10x12',
    desc: '10 x 12 APL Level III+ Plate, 4.75 lbs.',
    manu: 'United Shield International',
    price: '$1,060.00',
  },
  {
    id: 'APL- RF2-200-8x10',
    desc: '8 x 10 APL Level III+ Plate, 3.2 lbs.',
    manu: 'United Shield International',
    price: '$810.00',
  },
  {
    id: 'APL- RF2-200-6x6',
    desc: '6 x 6 APL Level III+ Plate, 1.44 lbs.',
    manu: 'United Shield International',
    price: '$590.00',
  },
  {
    id: 'APL- RF2-300-10x12',
    desc: '10 x 12 APL Level III+ Plate, 3.9 lbs.',
    manu: 'United Shield International',
    price: '$1,430.00',
  },
  {
    id: 'APL- RF2-300-8x10',
    desc: '8 x 10 APL Level III+ Plate, 2.5 lbs.',
    manu: 'United Shield International',
    price: '$1,020.00',
  },
  {
    id: 'APL- RF2-300-6x6',
    desc: '6 x 6 APL Level III+ Plate, 1.8 lbs.',
    manu: 'United Shield International',
    price: '$520.00',
  },
  {
    id: 'APL- RF2-350-10x12',
    desc: '10 x 12 APL Level III+ Plate, 3.8 lbs.',
    manu: 'United Shield International',
    price: '$1,070.00',
  },
  {
    id: 'APL- RF2-350-8x10',
    desc: '8 x 10 APL Level III+ Plate, 2.5 lbs.',
    manu: 'United Shield International',
    price: '$960.00',
  },
  {
    id: 'APL-RF3-100-10x12',
    desc: '10 x 12 APL Level IV Plate, 7.8 lbs.',
    manu: 'United Shield International',
    price: '$360.00',
  },
  {
    id: 'APL-RF3-100-8x10',
    desc: '8 x 10 APL Level IV Plate 4.9 lbs',
    manu: 'United Shield International',
    price: '$341.00',
  },
  {
    id: 'APL-RF3-100-6x6',
    desc: '6 x 6 APL Level IV Plate 3.3 lbs',
    manu: 'United Shield International',
    price: '$266.00',
  },
  {
    id: 'APL- RF3-200-10x12',
    desc: '10 x 12 APL Level IV Plate, 6.5 lbs.',
    manu: 'United Shield International',
    price: '$1,270.00',
  },
  {
    id: 'APL- RF3-200-8x10',
    desc: '8 x 10 APL Level IV Plate, 4.1 lbs.',
    manu: 'United Shield International',
    price: '$1,070.00',
  },
  {
    id: 'APL- RF3-200-6x6',
    desc: '6 x 6 APL Level IV Plate, 1.8 lbs.',
    manu: 'United Shield International',
    price: '$280.00',
  },
  {
    id: 'APL- RF3-300-10x12',
    desc: '10 x 12 APL Level IV Plate, 4.9 lbs.',
    manu: 'United Shield International',
    price: '$3,100.00',
  },
  {
    id: 'APL- RF3-300-8x10',
    desc: '8 x 10 APL Level IV Plate, 3.2 lbs',
    manu: 'United Shield International',
    price: '$2,760.00',
  },
  {
    id: 'APL- RF3-300-6x6',
    desc: '6 x 6 APL Level IV Plate, 1.8 lbs',
    manu: 'United Shield International',
    price: '$600.00',
  },
  {
    id: 'ThetaPGenII-10x12-211',
    desc: '10 x 12 Special threat Rifle Plate, 4.9 lbs.',
    manu: 'United Shield International',
    price: '$600.00',
  },
  {
    id: 'ThetaPGenII-8x10-211',
    desc: '8 x 10 Special threat Rifle Plate,',
    manu: 'United Shield International',
    price: '$490.00',
  },
  {
    id: 'ThetaPGenII-6x8-110',
    desc: '6 x 8 Special threat Rifle Plate, 2.3 lbs.',
    manu: 'United Shield International',
    price: '$320.00',
  },
  {
    id: 'ThetaPGenII-6x6-110',
    desc: '6 x 6 Special threat Rifle Plate, 1.7 lbs.',
    manu: 'United Shield International',
    price: '$300.00',
  },
  {
    id: 'SPA-GenII-IIIA-FEM-5x7',
    desc: '5 x 7 Spartan Gen II Level IIIA Stand Alone Stab level 1 plate, 0.35 lbs., Female Curved',
    manu: 'United Shield International',
    price: '$200.00',
  },
  {
    id: 'SPA-GenII-IIIA FEM-5x8',
    desc: '5 x 8 Spartan Gen II Level IIIA Stand Alone Stab level 1 Plate, 0.40 lbs., Female Curved',
    manu: 'United Shield International',
    price: '$207.00',
  },
  {
    id: 'SPA-GenII-IIIA-FEM-7x9',
    desc: '7 x 9 Spartan Gen II Level IIIA Stand Alone Stab level 1 Plate, 0.65 lbs., Female Curved',
    manu: 'United Shield International',
    price: '$254.00',
  },
  {
    id: 'SPA-GenII-IIIA-5x8-(curved or flat)',
    desc: '5 x 8 Spartan Gen II Level IIIA Stand Alone Stab level 1 Plate, 0.40 lbs., Single Curved or Flat',
    manu: 'United Shield International',
    price: '$210.00',
  },
  {
    id: 'SPA-GenII-IIIA-7x9-(curved or flat)',
    desc: '7 x 9 Spartan Gen II Level IIIA Stand Alone Stab level 1 Plate, 0.65 lbs., Single Curved or Flat',
    manu: 'United Shield International',
    price: '$240.00',
  },
  {
    id: 'SPA-GenII-IIIA-8x10-(curved or flat)',
    desc: '8 x 10 Spartan Gen II Level IIIA Stand Alone Stab level 1 Plate, 0.75 lbs., Single Curved or Flat',
    manu: 'United Shield International',
    price: '$310.00',
  },
  {
    id: 'SPA-GenII-IIIA-10x12-(curved or flat)',
    desc: '10 x 12 Spartan Gen II Level IIIA Stand Alone Stab level 1 Plate, 1.10 lbs., Single Curved or Flat',
    manu: 'United Shield International',
    price: '$380.00',
  },
  {
    id: 'SPA-GenII-IIIA-11x16',
    desc: '11 x 16 Spartan Gen II Level IIIA Stand Alone Stab level 1 Plate, 2.3 lbs., Flat',
    manu: 'United Shield International',
    price: '$630.00',
  },
  {
    id: 'AS-III-SMBLK',
    desc: 'PASGT Helmet-Black, Helmet Size Small, Carrier-Black (one size)',
    manu: 'United Shield International',
    price: '$1,180.00',
  },
  {
    id: 'AS-III-MDBLK',
    desc: 'PASGT Helmet-Black, Helmet Size Medium, Carrier-Black (one size)',
    manu: 'United Shield International',
    price: '$1,180.00',
  },
  {
    id: 'AS-III-LGBLK',
    desc: 'PASGT Helmet-Black, Helmet Size Large, Carrier-Black (one size)',
    manu: 'United Shield International',
    price: '$1,180.00',
  },
  {
    id: 'AS-III-XLBLK',
    desc: 'PASGT Helmet-Black, Helmet Size Xlarge, Carrier-Black (one size)',
    manu: 'United Shield International',
    price: '$1,180.00',
  },
  {
    id: 'AS-III-SMOD',
    desc: 'PASGT Helmet-OD Green, Helmet Size Small, Carrier-OD Green (one size)',
    manu: 'United Shield International',
    price: '$1,180.00',
  },
  {
    id: 'AS-III-MDOD',
    desc: 'PASGT Helmet-OD Green, Helmet Size Medium, Carrier-OD Green (one size)',
    manu: 'United Shield International',
    price: '$1,180.00',
  },
  {
    id: 'AS-III-LGOD',
    desc: 'PASGT Helmet-OD Green, Helmet Size Large, Carrier-OD Green (one size)',
    manu: 'United Shield International',
    price: '$1,180.00',
  },
  {
    id: 'AS-III-XLOD',
    desc: 'PASGT Helmet-OD Green, Helmet Size Xlarge, Carrier-OD Green (one size)',
    manu: 'United Shield International',
    price: '$1,180.00',
  },
  {
    id: 'AS-III-SMCY',
    desc: 'PASGT Helmet-Coyote, Helmet Size Small, Carrier-Coyote (one size)',
    manu: 'United Shield International',
    price: '$1,180.00',
  },
  {
    id: 'AS-III-MDCY',
    desc: 'PASGT Helmet-Coyote, Helmet Size Medium, Carrier-Coyote (one size)',
    manu: 'United Shield International',
    price: '$1,180.00',
  },
  {
    id: 'AS-III-LGCY',
    desc: 'PASGT Helmet-Coyote, Helmet Size Large, Carrier-Coyote (one size)',
    manu: 'United Shield International',
    price: '$1,180.00',
  },
  {
    id: 'AS-III-XLCY',
    desc: 'PASGT Helmet-Coyote, Helmet Size Xlarge, Carrier-Coyote (one size)',
    manu: 'United Shield International',
    price: '$1,180.00',
  },
  {
    id: 'AS-IV-ASC-SMBLK',
    desc: 'PASGT Helmet-Black, Helmet Size Small, Carrier-Black (one size)',
    manu: 'United Shield International',
    price: '$1,310.00',
  },
  {
    id: 'AS-IV-ASC-MDBLK',
    desc: 'PASGT Helmet-Black, Helmet Size Medium, Carrier-Black (one size)',
    manu: 'United Shield International',
    price: '$1,310.00',
  },
  {
    id: 'AS-IV-ASC-LGBLK',
    desc: 'PASGT Helmet-Black, Helmet Size Large, Carrier-Black (one size)',
    manu: 'United Shield International',
    price: '$1,310.00',
  },
  {
    id: 'AS-IV-ASC-XLBLK',
    desc: 'PASGT Helmet-Black, Helmet Size Xlarge, Carrier-Black (one size)',
    manu: 'United Shield International',
    price: '$1,310.00',
  },
  {
    id: 'AS-IV-ASC-SMOD',
    desc: 'PASGT Helmet-OD Green, Helmet Size Small, Carrier-OD Green (one size)',
    manu: 'United Shield International',
    price: '$1,310.00',
  },
  {
    id: 'AS-IV-ASC-MDOD',
    desc: 'PASGT Helmet-OD Green, Helmet Size Medium, Carrier-OD Green (one size)',
    manu: 'United Shield International',
    price: '$1,310.00',
  },
  {
    id: 'AS-IV-ASC-LGOD',
    desc: 'PASGT Helmet-OD Green, Helmet Size Large, Carrier-OD Green (one size)',
    manu: 'United Shield International',
    price: '$1,310.00',
  },
  {
    id: 'AS-IV-ASC-XLOD',
    desc: 'PASGT Helmet-OD Green, Helmet Size Xlarge, Carrier-OD Green (one size)',
    manu: 'United Shield International',
    price: '$1,310.00',
  },
  {
    id: 'AS-IV-ASC-SMCY',
    desc: 'PASGT Helmet-Coyote, Helmet Size Small, RPSS Carrier-Coyote (one size)',
    manu: 'United Shield International',
    price: '$1,310.00',
  },
  {
    id: 'AS-IV-ASC-MDCY',
    desc: 'PASGT Helmet-Coyote, Helmet Size Medium, RPSS Carrier-Coyote (one size)',
    manu: 'United Shield International',
    price: '$1,310.00',
  },
  {
    id: 'AS-IV-ASC-LGCY',
    desc: 'PASGT Helmet-Coyote, Helmet Size Large, RPSS Carrier-Coyote (one size)',
    manu: 'United Shield International',
    price: '$1,310.00',
  },
  {
    id: 'AS-IV-ASC-XLCY',
    desc: 'PASGT Helmet-Coyote, Helmet Size Xlarge, RPSS Carrier-Coyote (one size)',
    manu: 'United Shield International',
    price: '$1,310.00',
  },
  {
    id: 'AS-Bag',
    desc: 'Bag to Fit Active Shooter Kit including 2 plates, 1 carrier and 1 helmet',
    manu: 'United Shield International',
    price: '$115.00',
  },
];

const tableBody = document.querySelector('.table__catalog tbody');

catalog.forEach(item => {
  const row = document.createElement('tr');
  // Create cells for ID, Description, and Price
  const idCell = document.createElement('td');
  idCell.textContent = item.id;

  const descCell = document.createElement('td');
  descCell.textContent = item.desc;

  const manuCell = document.createElement('td');
  manuCell.textContent = item.manu;

  const priceCell = document.createElement('td');
  priceCell.textContent = item.price;

  // Append the cells to the row
  row.appendChild(idCell);
  row.appendChild(descCell);
  row.appendChild(manuCell);
  row.appendChild(priceCell);

  // Append the row to the table body
  tableBody.appendChild(row);
});
